
import { observable, action } from 'mobx';
import { Admin, CallSIPRegistration, Contact, Entity } from '../..';

export default class CallUser extends Entity {
    constructor(callUser?: Partial<CallUser>) {
        super(callUser);
        if (callUser) this.update(callUser);
    }

    /// <summary>
    /// true - platform incoming
    /// false - platform outgoing
    /// null - forwarding
    /// </summary>
    @observable incoming: boolean | null;
    @observable number: string;
    @observable admin: Admin;
    @observable contact: Contact;
    @observable durationInSec: number;
    @observable providerCost: number;
    @observable successful: boolean;
    @observable sipRegistration: CallSIPRegistration | null;

    static fromJson(json: any): CallUser {
        return new CallUser({
            ...json,
            admin: json.admin ? Admin.fromJson(json.admin) : undefined,
            contact: json.contact ? Contact.fromJson(json.contact) : undefined,
            sipRegistration: json.sipRegistration ? CallSIPRegistration.fromJson(json.sipRegistration) : null,
        });
    }

    @action
    update(callUser: Partial<CallUser>) {
        super.update(callUser);
    }
}

